import { useState, lazy, Suspense } from "react";
import { Button } from "@/components/ui/button";
import { BrandLogos } from "@/components/BrandLogos";
import paLogo from "@/assets/pa-logo.png";

// Lazy load BriefFormDialog - only needed when user clicks CTA
const BriefFormDialog = lazy(() => import("@/components/BriefFormDialog").then(m => ({ default: m.BriefFormDialog })));

export const HeroSection = () => {
  const [briefOpen, setBriefOpen] = useState(false);

  return (
    <>
      <section className="relative w-full h-screen overflow-hidden">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline 
            preload="metadata"
            poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1920' height='1080'%3E%3Crect fill='%23000000' width='100%25' height='100%25'/%3E%3C/svg%3E"
            className="w-full h-full object-cover"
            onCanPlay={(e) => e.currentTarget.play().catch(() => {})}
            onError={(e) => e.currentTarget.style.display = 'none'}
          >
            <source src="/videos/hero-background.webm" type="video/webm" />
          </video>
          {/* Overlay for contrast */}
          <div className="absolute inset-0" style={{
            backgroundColor: "rgba(0, 0, 0, 0.30)"
          }} />
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-start h-full text-center px-4 md:px-6 pt-[8vh] md:pt-[10vh]">
          {/* Logo */}
          <div className="mb-6 md:mb-7">
            <img src={paLogo} alt="PA Logo" width={180} height={180} fetchPriority="high" decoding="sync" loading="eager" className="w-[26vw] md:w-[14vw] max-w-[180px] min-w-[110px]" />
          </div>

          {/* Text Block - vertical flow */}
          <div className="max-w-4xl">
            {/* Main Heading */}
            <h1 style={{
              fontSize: "clamp(26px, 3.6vw, 52px)",
              lineHeight: "1.15",
              letterSpacing: "0.015em"
            }} className="text-white mb-5 md:mb-6 text-4xl font-bold">
              НОВЫЙ СТАНДАРТ ВИЗУАЛЬНОГО МАРКЕТИНГА
            </h1>
            
            {/* Slogan - breathing pulse effect */}
            <p style={{
              fontSize: "clamp(13px, 1.3vw, 17px)",
              letterSpacing: "0.03em",
              backgroundImage: "linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.70) 60%, rgba(255,255,255,0.18) 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent"
            }} className="lowercase pa-slogan text-sm font-light mb-7 md:mb-8">
              делаем то, что не могут другие
            </p>
            
            {/* CTA Button - light wave on hover - smaller on mobile */}
            <div>
              <Button 
                variant="outline-sweep" 
                className="px-5 py-2 md:px-10 md:py-3" 
                style={{
                  fontSize: "clamp(9px, 1vw, 13px)"
                }} 
                onClick={() => setBriefOpen(true)}
                aria-label="НАЧАТЬ ВМЕСТЕ С НАМИ - сотрудничество с PROPAGANDA AI"
              >
                <span className="text-[10px] md:text-sm font-normal">НАЧАТЬ ВМЕСТЕ С НАМИ</span>
              </Button>
            </div>
          </div>
        </div>

        {/* Brand Logos - inside hero at bottom */}
        <div className="absolute bottom-[60px] md:bottom-[80px] left-0 right-0 z-30">
          <BrandLogos />
        </div>

        {/* Smooth fade transition to black */}
        <div className="absolute bottom-0 left-0 right-0 h-[250px] pointer-events-none z-20" style={{
          background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)'
        }} />
      </section>
      
      {briefOpen && (
        <Suspense fallback={null}>
          <BriefFormDialog open={briefOpen} onOpenChange={setBriefOpen} />
        </Suspense>
      )}
    </>
  );
};
